if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'pre') { // keep code style for tree shaking
  try {
    const localStorage = window[atob('bG9jYWxTdG9yYWdl')]
    const getItem = atob('Z2V0SXRlbQ==')
    const key = atob('ZGVidWdfaW5zaWdu')

    if (typeof localStorage[getItem] === 'function' && localStorage[getItem](key) === 'true') {
      // eslint-disable-next-line no-debugger
      debugger
    }
  } catch (e) {
    console.warn('Can not use')
  }
}
